/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Box,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tooltip,
} from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import AddReply from "../../Modals/addReply";
import usePermission from "../../hooks/usePermission";
import useTranslation from "../../hooks/traslation";

const CustomerSupportList = () => {
  const navigate = useNavigate();
  const translation = useTranslation();

  const { isAdd, isDelete } = usePermission({
    label: "Report & Disputes",
    page_permission: "isView",
  });

  const [selectField1, setSelectField1] = React.useState("default");
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };

  const rows = [
    {
      id: 1,
      title: "How do I sign up as a maintenance provider?",
      description:
        "Our Property Maintenance App is designed to simplify and streamline the process of managing property repairs and maintenance. Whether it's a leaky tap, plumbing issues, electrical work, or routine maintenance, our app makes it easy to request, track, and resolve all maintenance needs.",
      date: "01 March 2025",
    },
    {
      id: 2,
      title: "How do I sign up as a maintenance provider?",
      description:
        "Our Property Maintenance App is designed to simplify and streamline the process of managing property repairs and maintenance. Whether it's a leaky tap, plumbing issues, electrical work, or routine maintenance, our app makes it easy to request, track, and resolve all maintenance needs.",
      date: "01 March 2025",
    },
    {
      id: 3,
      title: "How do I sign up as a maintenance provider?",
      description:
        "Our Property Maintenance App is designed to simplify and streamline the process of managing property repairs and maintenance. Whether it's a leaky tap, plumbing issues, electrical work, or routine maintenance, our app makes it easy to request, track, and resolve all maintenance needs.",
      date: "01 March 2025",
    },
    {
      id: 4,
      title: "How do I sign up as a maintenance provider?",
      description:
        "Our Property Maintenance App is designed to simplify and streamline the process of managing property repairs and maintenance. Whether it's a leaky tap, plumbing issues, electrical work, or routine maintenance, our app makes it easy to request, track, and resolve all maintenance needs.",
      date: "01 March 2025",
    },
    {
      id: 5,
      title: "How do I sign up as a maintenance provider?",
      description:
        "Our Property Maintenance App is designed to simplify and streamline the process of managing property repairs and maintenance. Whether it's a leaky tap, plumbing issues, electrical work, or routine maintenance, our app makes it easy to request, track, and resolve all maintenance needs.",
      date: "01 March 2025",
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 220,
      field: "name",
      headerName: translation.main.freelancerDetail,
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div
            className="user_block click_action"
            onClick={() => navigate("/manage-employers/detail")}
          >
            <figure>
              <img src="/static/images/user_placeholder.png" alt="" />
            </figure>
            <p>
              <b>Madelyn Dias</b> <span>madelyndias@gmail.com</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 2,
      minWidth: 220,
      field: "title",
      headerName: translation.globals.title,
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
    },
    {
      minWidth: 180,
      field: "status",
      headerName: translation.globals.status,
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <Select
            fullWidth
            value={selectField1}
            onChange={handleChange1}
            disabled={isAdd ? false : true}
          >
            <MenuItem disabled value="default">
              {translation.main.selectStatus}
            </MenuItem>
            <MenuItem value={10}>{translation.main.pending}</MenuItem>
            <MenuItem value={20}>{translation.main.Resolved}</MenuItem>
          </Select>
        );
      },
    },
    {
      minWidth: 100,
      field: "action",
      headerName: translation.globals.actions,
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="table_actions v2">
            <Box>
              <Tooltip title={translation.main.Reply}>
                <IconButton onClick={() => setOpen(true)}>
                  <img src="/static/images/reply_icon.svg" alt="" />
                </IconButton>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={translation.globals.Delete}>
                <IconButton>
                  <img src="/static/images/trash2_icon.svg" alt="" />
                </IconButton>
              </Tooltip>
            </Box>
          </div>
        );
      },
    },
  ];

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent columns={columns} rows={rows} />
      </div>

      <AddReply open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </>
  );
};

export default CustomerSupportList;
